import {Component} from 'react'
import Cookies from 'js-cookie'
import {Redirect} from 'react-router-dom'
import tastyKitchensLogo from '../Gallery/TastyKitchens.png'

import './index.css'

class Login extends Component {
  state = {
    username: '',
    password: '',
    showSubmitError: false,
    errorMsg: '',
  }

  onChangeUsername = event => {
    this.setState({username: event.target.value})
  }

  onChangePassword = event => {
    this.setState({password: event.target.value})
  }

  onSubmitSuccess = (jwtToken, expiryDays) => {
    const {history} = this.props

    Cookies.set('jwt_token', jwtToken, {
      expires: expiryDays,
    })
    history.replace('/')
  }

  onSubmitFailure = errorMessage => {
    this.setState({errorMsg: errorMessage, showSubmitError: true})
  }

  submitForm = async event => {
    event.preventDefault()
    const {username, password} = this.state

    this.onSubmitLoginCredentials(username, password, 7)
  }

  onSubmitLoginCredentials = async (username, password, expiryDays) => {
    const userDetails = {username, password}
    const url = 'https://apis.ccbp.in/login'
    const options = {
      method: 'POST',
      body: JSON.stringify(userDetails),
    }
    const response = await fetch(url, options)
    const data = await response.json()
    if (response.ok === true) {
      this.onSubmitSuccess(data.jwt_token, expiryDays)
    } else {
      this.onSubmitFailure(data.error_msg)
    }
  }

  guestLogin = async event => {
    event.preventDefault()

    this.onSubmitLoginCredentials('rahul', 'rahul@2021', 1)
  }

  renderPasswordField = () => {
    const {password} = this.state
    return (
      <>
        <label className="input-label" htmlFor="password">
          PASSWORD
        </label>
        <div className="password-container">
          <input
            type="password"
            id="password"
            className="password-input-field"
            value={password}
            onChange={this.onChangePassword}
            placeholder="Password"
          />
        </div>
      </>
    )
  }

  renderUsernameField = () => {
    const {username} = this.state
    return (
      <>
        <label className="input-label" htmlFor="username">
          USERNAME
        </label>
        <input
          type="text"
          id="username"
          className="username-input-field"
          value={username}
          onChange={this.onChangeUsername}
          placeholder="Username"
        />
      </>
    )
  }

  render() {
    const jwtToken = Cookies.get('jwt_token')
    if (jwtToken !== undefined) {
      return <Redirect to="/" />
    }
    const {showSubmitError, errorMsg} = this.state
    return (
      <div className="login-container">
        <div className="login-form-container">
          <div className="small-device-logo-container">
            <img
              className="small-device-logo"
              src="https://res.cloudinary.com/sravangunaganti/image/upload/v1652874330/TastyKitchens/Rectangle_1457_z2svbb.png"
              alt="website login"
            />
          </div>
          <form className="form-container" onSubmit={this.submitForm}>
            <img
              className="large-device-logo"
              src={tastyKitchensLogo}
              alt="website logo"
            />
            <h1 className="login-heading-ele">Tasty Kitchens</h1>

            <h1 className="login-text-heading">Login</h1>
            <div className="input-container">{this.renderUsernameField()}</div>
            <div className="input-container">{this.renderPasswordField()}</div>
            <div className="login-button-container">
              <button type="submit" className="login-button">
                Login
              </button>
              <button
                type="button"
                className="guest-login-button"
                onClick={this.guestLogin}
              >
                Guest Login
              </button>
            </div>

            {showSubmitError && <p className="error-message">{errorMsg}</p>}
          </form>
        </div>

        <div className="image-container">
          <img
            className="welcome-image"
            src="https://res.cloudinary.com/sravangunaganti/image/upload/v1652874318/TastyKitchens/Rectangle_1456_mxjrer.png"
            alt="web"
          />
        </div>
      </div>
    )
  }
}

export default Login
